import { useEffect } from 'react';

interface AvatarUrls {
  userAvatar?: string | null;
  directorAvatar?: string | null;
  pbmAvatar?: string | null;
}

export const usePreloadAvatars = (avatars: AvatarUrls) => {
  useEffect(() => {
    const preloadImage = (url: string) => {
      const img = new Image();
      img.src = url;
    };

    if (avatars.userAvatar) {
      preloadImage(avatars.userAvatar);
    }
    if (avatars.directorAvatar) {
      preloadImage(avatars.directorAvatar);
    }
    if (avatars.pbmAvatar) {
      preloadImage(avatars.pbmAvatar);
    }
  }, [avatars.userAvatar, avatars.directorAvatar, avatars.pbmAvatar]);
};
